import React from 'react';
import {
  ResourcingLegends,
  resourcingLegendItems
} from '~/modules/resourcing/common/components';

const legends = [
  resourcingLegendItems.allocatedProgress,
  resourcingLegendItems.overAllocated,
  resourcingLegendItems.notWorking
];

export const ResourceLegendComponent = () => {
  return <ResourcingLegends legends={legends} />;
};

export default ResourceLegendComponent;
